import type { Components } from "@mui/material/styles";

export const MuiTooltip: Components["MuiTooltip"] = {
  styleOverrides: {
    tooltip: {
      padding: "0.5rem 0.75rem",
      fontSize: "var(--font-size-s)",
      backgroundColor: "var(--color-blue)",
    },
    arrow: {
      color: "var(--color-blue)",
    },
  },
};
